const wishlistPageProductHandle = (du) => {
  try {
    let url = new URL(du, window.location.origin);
    let parts = url.pathname.split('/products/');
    return parts[1] ? parts[1].split('/')[0].split('?')[0] : null;
  } catch (e) {
    return null;
  }
};

const wishlistPageFetchCardHtml = (handle, variantId) => {
  return fetch(`${window.location.origin}/products/${handle}?variant=${variantId}&section_id=wishlist-card`)
    .then((res) => (res.ok ? res.text() : ''))
    .catch(() => '');
};

const wishlistPageInit = (swat) => {
  document.querySelectorAll('[data-swym-wishlist-page-section]').forEach((grid) => {
      let root = grid.closest('.swym-wishlist-page');
    let loading = root.querySelector(`.swym-wishlist-loading`);
    let empty = root.querySelector(`.swym-wishlist-empty`);
    let countEl = root.querySelector(`.swym-wishlist-count`);

    let i18n = {
      countSingular: root.dataset.i18nCountSingular,
      countMultiple: root.dataset.i18nCountMultiple,
    };

    const updateCountAndEmptyState = (itemCount) => {
      if (itemCount === 0) {
        grid.style.display = 'none';
        if (empty) empty.style.display = 'block';
        if (countEl) countEl.textContent = '';
      } else {
        if (empty) empty.style.display = 'none';
        grid.style.display = 'grid';
        if (countEl) {
          countEl.textContent = itemCount === 1
            ? i18n.countSingular
            : i18n.countMultiple.replace('[[ count ]]', itemCount);
        }
      }
    };

    const load = () => {
      swat.fetchLists({
        callbackFn: async (lists) => {
          let list = (Array.isArray(lists) ? lists : lists ? [lists] : [])[0];
          let items = (list && (list.listcontents || list.listContents || list.contents)) || [];

          if (loading) loading.style.display = 'none';
          updateCountAndEmptyState(items.length);
          if (!items.length) return;

          let htmls = await Promise.all(items.map((item) => {
            let handle = wishlistPageProductHandle(item.du);
            return handle ? wishlistPageFetchCardHtml(handle, item.epi) : Promise.resolve('');
          }));

          grid.innerHTML = htmls.join('');
        },
        errorFn: () => {
          if (loading) loading.style.display = 'none';
        },
      });
    };

    load();

    if (swat.evtLayer && swat.JSEvents) {
      swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, load);
    }
  });
};

if (!window.SwymCallbacks) window.SwymCallbacks = [];
window.SwymCallbacks.push(wishlistPageInit);
